import { combineReducers } from 'redux';
import { IApplicationStore } from '../interfaces';
import reservationReducer from './reservation/reservation-reducer';
import restaurantReducer from './restaurant/restaurant-reducer';
import cancelReservationReducer from './cancelReservation/cancelReservation-reducer';

const rootReducer = combineReducers<IApplicationStore>({
    reservation: reservationReducer,
    restaurant: restaurantReducer,
    cancelReservation: cancelReservationReducer,
});

export default rootReducer;
